module.exports = __webpack_public_path__ + "static/media/playBtn.e3080430.svg";